import { useNavigate, useSearchParams } from "react-router-dom";
import { Package, Monitor, ChevronLeft, Terminal } from "lucide-react";
import OSPatchManagement from "./OSPatchManagement";
import PatchManagement from "./PatchManagement";
import Jobs from "../Settings/Scheduler/Jobs";


export default function PatchJobsMain() {
    const [searchParams, setSearchParams] = useSearchParams();
    const prev = searchParams.get("prev") || "application";
    const navigate = useNavigate();

    // Read from URL, default to 'application' if not set or invalid
    const activeTab = searchParams.get("tab") === "os" ? "os" : searchParams.get("tab") === "script" ? "script" : "application";

    // Update URL when switching tabs while preserving other params (like 'prev')
    const handleTabChange = (tab: 'application' | 'os'| 'script') => {
        setSearchParams((prevParams) => {
            prevParams.set("tab", tab);
            return prevParams;
        });
    };

    return (
        <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200 w-full max-w-full overflow-x-hidden">
            {/* Header / Tabs Navigation */}
            <div className="flex items-center gap-2 sm:gap-3 bg-white dark:bg-gray-900/90 backdrop-blur-md p-2 sm:p-2.5 border-b border-gray-200 dark:border-gray-800 shadow-sm sticky top-0 z-20 transition-colors duration-200 max-w-full min-w-0">

                <button
                    onClick={() => navigate(`/patching?tab=${prev}`)}
                    className="flex items-center justify-center p-2 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-all shadow-sm shrink-0 group"
                    title="Back to Patching"
                >
                    <ChevronLeft size={16} className="text-gray-600 dark:text-gray-400 group-hover:text-orange-500 transition-colors" />
                </button>

                {/* Tabs */}
                <div className="flex items-center overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden bg-gray-100 dark:bg-gray-800/90 p-1 border rounded-lg border-gray-200 dark:border-gray-700/80 max-w-full gap-1">
                    <button
                        onClick={() => handleTabChange('application')}
                        className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-[10px] sm:text-[11px] font-bold uppercase tracking-wider sm:tracking-widest transition-all duration-200 border whitespace-nowrap shrink-0 ${activeTab === 'application'
                            ? 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-600 text-orange-600 dark:text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-white/60 dark:hover:bg-gray-700/50'
                            }`}
                    >
                        <Package size={14} className="shrink-0" />
                        <span>Application Jobs</span>
                    </button>
                    <button
                        onClick={() => handleTabChange('os')}
                        className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-[10px] sm:text-[11px] font-bold uppercase tracking-wider sm:tracking-widest transition-all duration-200 border whitespace-nowrap shrink-0 ${activeTab === 'os'
                            ? 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-600 text-orange-600 dark:text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-white/60 dark:hover:bg-gray-700/50'
                            }`}
                    >
                        <Monitor size={14} className="shrink-0" />
                        <span>OS Patching Jobs</span>
                    </button>
                    <button
                        onClick={() => handleTabChange('script')}
                        className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-[10px] sm:text-[11px] font-bold uppercase tracking-wider sm:tracking-widest transition-all duration-200 border whitespace-nowrap shrink-0 ${activeTab === 'script'
                            ? 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-600 text-orange-600 dark:text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-white/60 dark:hover:bg-gray-700/50'
                            }`}
                    >
                        <Terminal size={14} className="shrink-0" />
                        <span>Script Jobs</span>
                    </button>
                </div>
            </div>

            {/* Tab Content */}
            <div className="flex-1 min-w-0">
                {activeTab === 'application' && <PatchManagement />}
                {activeTab === 'os' && <OSPatchManagement />}
                {activeTab === 'script' && <Jobs scriptjobs={true} />}
            </div>
        </div>
    );
}